// extracted by mini-css-extract-plugin
export default {"banner":"banner-module--banner--hlJgp","bannerWrap":"banner-module--bannerWrap--yQ9bg","text":"banner-module--text--05U21","pic":"banner-module--pic--96Uvg"};